var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{directives:[{name:"a11y-tab",rawName:"v-a11y-tab:tab-line",arg:"tab-line"}],class:[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']},[_c('a',{attrs:{"href":href},on:{"click":navigate}},[_vm._v(_vm._s(_vm.label || route.fullPath))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }